export default {
  title: {
    normal: 'Nouveau mot de passe',
    first: 'Enregistrer un mot de passe',
  },
  login: 'Votre adresse email',
  loginWarning: 'Email non valide. Veuillez renseigner l\'adresse email liée à votre compte.',
  password: 'Votre nouveau mot de passe',
  passwordWarning: 'Veuillez renseigner un mot de passe',
  lengthCondition: 'Le mot de passe doit faire au minimum 10 caractères',
  lengthCondition2: 'Le mot de passe doit faire au minimum 8 caractères',
  caseCondition: 'Le mot de passe doit contenir une minuscule et une majuscule',
  specialCondition: 'Le mot de passe doit contenir un caractère spécial (caractère hors chiffres/lettres)',
  passwordConfirmation: 'Confirmez le mot de passe',
  passwordConfirmationWarning: 'Veuillez confirmer le mot de passe',
  passwordConfirmationEqual: 'Le mot de passe et sa confirmation ne sont pas égaux',
  submit: {
    first: 'Mettre un mot de passe',
    normal: 'Changer le mot de passe',
  },
  loginPage: 'Se connecter',
  registerText: 'Besoin d\'un compte Nextories ?',
  registerBtn: 'Créer un compte',
  alert: {
    title: 'Votre lien a expiré',
    message: 'Veuillez refaire une demande de réinitialisation de mot de passe en cliquant sur le bouton ci-dessous.',
  },
  recoverPassword: 'Réinitialiser mon mot de passe',
  rules: {
    title: 'Votre mot de passe doit contenir :',
    lengthCondition: 'Au minimum 10 caractères',
    lengthCondition2: 'Au minimum 8 caractères',
    caseCondition: 'Une minuscule et une majuscule',
    specialCondition: 'Un caractère spécial (caractère hors chiffres/lettres)',
  },
};
